import { FormikProps } from 'formik';
import React from 'react';
import { LabelAndValue } from '../../../../global/components/data-display/label-value';
import { FormField } from '../../../../global/components/form-element/form-field';
import { FormGroup } from '../../../../global/components/layout/form-group';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { SearchPerson } from './person-search-model';

interface Props {    
    personEmailLabel: string;    
    formProps: FormikProps<any>;
    selectedPerson: SearchPerson;
}

export function PersonEmailRequiredDisplay(props: Props) {
    const { 
        formProps,
        personEmailLabel,        
        selectedPerson } = props;

    const renderPersonEmail = () => {
        if (!selectedPerson) {
            return (
                <LabelAndValue label={personEmailLabel} value={formProps.values.personal_email_address} />
            );
        }

        return (
            <FormGroup>

                <FormField
                    name='personal_email_address'
                    component='input'
                    label={personEmailLabel}
                    touched={formProps.touched}
                    errors={formProps.errors}
                    required
                />
            </FormGroup>
        );
    };

    return (
        <ContentSpacer>            
            {renderPersonEmail()}
        </ContentSpacer>
    );
}